<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,8.009999990463257C12,7.8199999904632564,11.93,7.6499999904632565,11.84,7.499999990463257C11.84,7.499999990463257,11.85,7.489999990463257,11.85,7.489999990463257C11.85,7.489999990463257,8.85,2.489999990463257,8.85,2.489999990463257C8.85,2.489999990463257,8.84,2.499999990463257,8.84,2.499999990463257C8.67,2.209999990463257,8.36,2.009999990463257,8,2.009999990463257C7.640000000000001,2.009999990463257,7.33,2.209999990463257,7.16,2.499999990463257C7.16,2.499999990463257,7.140000000000001,2.489999990463257,7.140000000000001,2.489999990463257C7.140000000000001,2.489999990463257,4.14,7.489999990463257,4.14,7.489999990463257C4.14,7.489999990463257,4.16,7.499999990463257,4.16,7.499999990463257C4.07,7.6499999904632565,4,7.8199999904632564,4,8.009999990463257C4,8.199999990463258,4.07,8.369999990463256,4.16,8.519999990463257C4.16,8.519999990463257,4.14,8.519999990463257,4.14,8.519999990463257C4.14,8.519999990463257,7.140000000000001,13.519999990463257,7.140000000000001,13.519999990463257C7.140000000000001,13.519999990463257,7.15,13.509999990463257,7.15,13.509999990463257C7.33,13.799999990463256,7.640000000000001,14.009999990463257,8,14.009999990463257C8.36,14.009999990463257,8.67,13.809999990463258,8.84,13.519999990463257C8.84,13.519999990463257,8.85,13.529999990463256,8.85,13.529999990463256C8.85,13.529999990463256,11.85,8.529999990463256,11.85,8.529999990463256C11.85,8.529999990463256,11.84,8.519999990463257,11.84,8.519999990463257C11.93,8.359999990463256,12,8.199999990463258,12,8.009999990463257C12,8.009999990463257,12,8.009999990463257,12,8.009999990463257Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SymbolDiamond',
} as DefineComponent
</script>
